module.exports = __webpack_public_path__ + "img/daily-mail.73cd161f.svg";